import type { DataSource } from './DataSource';
import { FileDataSource } from './FileDataSource';
import { ApiDataSource } from './ApiDataSource';

/**
 * Selects the active data source from build-time env, behind a stable interface.
 *
 *   VITE_DATA_SOURCE=files (default) -> static JSON files in /data (updatable
 *                                        without rebuilding the app)
 *   VITE_DATA_SOURCE=api             -> remote REST backend (VITE_API_BASE_URL)
 *
 * UI code never changes when the backend changes — swap the source here only.
 */
function createDataSource(): DataSource {
  const mode = (import.meta.env.VITE_DATA_SOURCE as string) || 'files';
  if (mode === 'api') {
    const base = (import.meta.env.VITE_API_BASE_URL as string) || '';
    if (!base) {
      console.error('VITE_DATA_SOURCE=api but VITE_API_BASE_URL is empty; falling back to files.');
      return new FileDataSource();
    }
    return new ApiDataSource(base.replace(/\/$/, ''));
  }
  return new FileDataSource();
}

export const dataService: DataSource = createDataSource();
